import { render, staticRenderFns } from "./no_product.vue?vue&type=template&id=9748ac9e&scoped=true&"
import script from "./no_product.vue?vue&type=script&lang=js&"
export * from "./no_product.vue?vue&type=script&lang=js&"
import style0 from "./no_product.vue?vue&type=style&index=0&id=9748ac9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9748ac9e",
  null
  
)

export default component.exports